export const order = 7;
export const routes = {
  path: "/",
  name: "postManagementLayout",
  component: () => import("@/views/layout"),
  meta: {
    title: "岗位管理",
    guard: {
      role: ["Admin"],
      permission: ["upms:postManagement"],
    },
  },
  children: [
    {
      path: "postManagementPage",
      name: "postManagementPage",
      meta: {
        title: "岗位管理",
        guard: {
          role: ["Admin"],
          permission: ["upms:postManagementPage"],
        },
      },
      children: [
        {
          path: "jobPosition",
          name: "jobPosition",
          meta: {
            title: "岗位职称",
            guard: {
              role: ["Admin"],
              permission: ["upms:postManagementPage:jobPosition"],
            },
          },
          component: () => import("@/views/postManagement/jobPosition.vue"),
        },
        {
          path: "operationLogs",
          name: "operationLogs",
          meta: {
            title: "操作日志",
            guard: {
              role: ["Admin"],
              permission: ["upms:postManagementPage:operationLogs"],
            },
          },
          component: () => import("@/views/postManagement/operationLogs.vue"),
        },
      ],
    },
  ],
};
export const perms = {
  jobPosition: [
    {
      title: "新增",
      permission: "upms:postManagementPage:jobPosition:add",
    },
    {
      title: "批量导入",
      permission: "upms:postManagementPage:jobPosition:imp",
    },
    {
      title: "同步职称信息",
      permission: "upms:postManagementPage:jobPosition:sync",
    },
    {
      title: "编辑",
      permission: "upms:postManagementPage:jobPosition:edit",
    },
    {
      title: "删除",
      permission: "upms:postManagementPage:jobPosition:del",
    },
  ],
};
